/**
 * @name EmployeeService
 * @description Servicio para gestionar la información del empleado
 * @author Ricardo Guerra
 */

import axios from 'axios';
import { Environment } from '@config';

// URL Administración Endpoint
const BASE_URL = Environment.getCurrent().endpoints.admin;

/**
 * Consulta los empleados de una empresa
 * @param {any} request filter { idPuesto, idNivel, idArea, idSucursal, idReporta, nombre, estatus, idAplicacion, codigoColaborador, ordenarPorFechaDeAlta, columnas}
 * @return {any} promise
 */
const get = (request) => {
  let jobId = request.filter.idPuesto === undefined ? '' : `&idPuesto=${request.filter.idPuesto}`;
  let levelId = request.filter.idNivel === undefined ? '' : `&idNivel=${request.filter.idNivel}`;
  let areaId = request.filter.idArea === undefined ? '' : `&idArea=${request.filter.idArea}`;
  let branchId = request.filter.idSucursal === undefined ? '' : `&idSucursal=${request.filter.idSucursal}`;
  let supervisorId = request.filter.idReporta === undefined ? '' : `&idReporta=${request.filter.idReporta}`;
  let name = request.filter.nombre === undefined ? '' : `&nombre=${request.filter.nombre}`;
  let status = request.filter.estatus === undefined ? '' : `&estatus=${request.filter.estatus}`;
  let appId = request.filter.idAplicacion === undefined ? '' : `&idAplicacion=${request.filter.idAplicacion}`;
  let codeEmployee = request.filter.codigoColaborador === undefined ? '' : `&codigoColaborador=${request.filter.codigoColaborador}`;
  let orderStartDate = request.filter.ordenarPorFechaDeAlta === undefined ? '' : `&ordenarPorFechaDeAlta=${request.filter.ordenarPorFechaDeAlta}`;
  let columns = request.columnas === undefined ? '' : `&columnas=${request.columnas}`;

  let URL = `${BASE_URL}/Empleado?paginado=${request.page},${request.size}${jobId}${levelId}${areaId}${branchId}${supervisorId}${name}${status}${appId}${codeEmployee}${orderStartDate}${columns}`;

  return axios.get(URL).then(({ data }) => {
    return data;
  });
};

/**
 * Consulta la información del usuario
 * @param {any} request IdEmpleado
 * @return {any} promise 
 */
const getOne = (request) => {
  let URL = `${BASE_URL}/Empleado/${request}`;

  return axios.get(URL).then(({ data }) => {
    return data;
  });
};

/**
 * Consulta información general del usuario
 * @return {any} promise
 */
const getInfo = () => {
  let URL = `${BASE_URL}/Empleado/InfoGeneral`;

  return axios.get(URL).then(({ data }) => {
    return data;
  });
};

/**
 * Consulta información general del usuario externo
 * @param {string} externalUser
 * @return {any} promise
 */
const getInfoExternal = (externalUser) => {
  let URL = `${BASE_URL}/EmpleadoExterno/InfoGeneral?Usuario=${externalUser}`;

  return axios.get(URL).then(({ data }) => {
    return data;
  });
};

/**
 * Consulta la estructura del empleado
 * @param {any} request filter { idAplicacion, tipoEstructura, estructuraDirecta, nombre, columnas}
 * @return {any} promise
 */
const getStructure = (request) => {
  let appId = request.filter.idAplicacion === undefined ? '' : `&idAplicacion=${request.filter.idAplicacion}`;
  let typeStructure = request.filter.tipoEstructura === undefined ? '' : `&tipoEstructura=${request.filter.tipoEstructura}`;
  let directStructure = request.filter.estructuraDirecta === undefined ? '' : `&estructuraDirecta=${request.filter.estructuraDirecta}`;
  let name = request.filter.nombre === undefined ? '' : `&nombre=${request.filter.nombre}`;
  let columns = request.columnas === undefined ? '' : `&columnas=${request.columnas}`;
  let URL = `${BASE_URL}/EmpleadoEstructura?paginado=${request.page},${request.size}${appId}${typeStructure}${directStructure}${name}${columns}`;

  return axios.get(URL).then(({ data }) => {
    return data;
  });
};

/**
 * Consulta la jerarquía del usuario
 * @return {int} 1: User, 2: Supervisor, 3: 3rd Level
 */
const getHierarchy = () => {
  let employee = JSON.parse(localStorage.getItem('ls.infoUsuario')).Empleado;
  return {
    level: employee.NivelJerarquia,
    employeeId: employee.IdEmpleado
  };
};

/**
 * Actualiza información del perfil del usuario
 * @param {any} request Empleado (tel, language)
 * @return {any} promise
 */
const putProfile = (request) => {
  let employee = {};
  let employeePhone = JSON.parse(localStorage.getItem('ls.infoUsuario')).Empleado.Telefono;

  if (request.phone) {
    employee.Telefono = request.phone;
  } else if (employeePhone === '') {
    employee.Telefono = request.phone;
  } else {
    employee.Telefono = employeePhone;
  }
  employee.Idioma = request.language;
  let URL = `${BASE_URL}/Empleado`;

  return axios.put(URL, employee).then(({ data }) => {
    return data;
  });
};

export const EmployeeService = {
  get,
  getOne,
  getInfo,
  getInfoExternal,
  getStructure,
  getHierarchy,
  putProfile,
};